<template>
  <v-card class="ma-auto card" flat align="center">
    <v-data-table :headers="headers" :items="errors" :items-per-page="10"></v-data-table>
  </v-card>
</template>

<script lang="ts">
import DarkModeHighlightMixin from "@/mixins/DarkModeHighlightMixin.vue";
import { ErrorLogModule } from "@/store/modules/error-log";
import { Component } from "vue-property-decorator";

@Component({})
export default class ErrorList extends DarkModeHighlightMixin {
  get headers() {
    return [
      {
        text: "Name",
        value: "name"
      },
      {
        text: "Message",
        value: "message"
      }
    ];
  }

  get errors() {
    return ErrorLogModule.logs;
  }
}
</script>
